<template>
  <div v-if="applicantProfile" id="applicant-edit-tab-personal-data">
    <ApplicationAs v-model="profile" />
    <div style="text-align: right">
      <vs-button class="my-3" @click="save()">Speichern</vs-button>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import ApplicationAs from "../form/ApplicationAs";
import editFormMixin from "@/mixins/editFormMixin.js";

export default {
  components: {
    ApplicationAs
  },
  mixins: [
    editFormMixin({
      idFields: ["availibilty", "jobExperience", "leadershipExperience"],
      legacyIDFields: ["driverLicenses", "wantedJobTypes", "wantedOccupations"],
      dataProp: "profile"
    })
  ],
  props: {
    profileId: { type: String, required: true }
  },
  data() {
    return {
      saveInterval: null,
      fetchFailed: false,
      deleteId: null
    };
  },
  apollo: {
    applicantProfile: {
      query: gql`
        query ApplicantProfile($id: ID!) {
          applicantProfile(id: $id) {
            id
            salaryIs
            salaryCar
            salaryWanted
            salaryFix
            salaryVariable
            driverLicenses {
              id
              name
            }
            wantedJobTypes {
              id
              name
            }
            wantedOccupation
            wantedOccupations {
              id
              name
            }
            profileNote
            ownCar
            mobilityMotorcycle
            mobilityBicycle
            mobilityPublicTransport
            mobilityRadius
            mobilityComment
            hobbies
            degree
            jobExperience {
              id
              name
            }
            leadershipExperience {
              id
              name
            }
            availibilty {
              id
              name
            }
            availibiltyCustom
          }
        }
      `,
      result() {
        this.updateCurrent();
      },
      variables() {
        return {
          id: this.profileId
        };
      }
    }
  },
  computed: {
    profile: {
      get() {
        return this.applicantProfile;
      },
      // eslint-disable-next-line
      set(v) {
        this.save(false);
      }
    }
  },
  watch: {
    profile: {
      deep: true,
      handler(v) {
        this.profile = v;
      }
    }
  },
  methods: {
    updateValue() {
      this.profile = this.applicantProfile;
    },
    refetchVacancies() {
      this.$apollo.queries["applicantApplicationsPage"].refetch();
    },
    confirmDeleteRecord(id) {
      this.deleteId = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Löschen bestätigen",
        text: `Du bist dabei eine Stellen Zuordnung zu löschen. Bist du sicher?`,
        accept: this.deleteRecord,
        acceptText: "Löschen",
        cancelText: "Abbrechen"
      });
    },
    deleteRecord() {
      this.$apollo
        .mutate({
          mutation: gql`
            mutation($applicantId: ID!, $applicationId: ID!) {
              removeApplication(
                applicantId: $applicantId
                applicationId: $applicationId
              ) {
                id
              }
            }
          `,
          variables: {
            applicationId: this.deleteId,
            applicantId: this.$route.params.id
          }
        })
        .then(() => {
          this.refetchVacancies();
        });
    },
    async persist() {
      let input = this.getInput();
      await this.$apollo
        .mutate({
          mutation: gql`
            mutation($id: ID!, $input: ApplicantProfileInput!) {
              updateApplicantProfile(id: $id, input: $input) {
                id
                wantedOccupations {
                  id
                  category {
                    id
                  }
                }
                applicant {
                  id
                }
              }
            }
          `,
          variables: {
            id: this.profileId,
            input
          }
        })
        .then(data => {
          const aplicantId = data.data.updateApplicantProfile.applicant.id;
          const wantedOccupations =
            data.data.updateApplicantProfile.wantedOccupations || [];
          const occupationCategoryIds = wantedOccupations
            .filter(o => o.category != null)
            .map(o => o.category.id);
          this.$apollo
            .mutate({
              mutation: gql`
                mutation($id: ID!, $input: ApplicantInput!) {
                  updateApplicant(id: $id, input: $input) {
                    id
                  }
                }
              `,
              variables: {
                id: aplicantId,
                input: {
                  occupationCategories: occupationCategoryIds
                }
              }
            })
            .then(data => console.log(data))
            .catch(error => console.log(error));
          return data;
        })
        // eslint-disable-next-line
        .then((data) => {
          this.reportSuccess(input);
        })
        .catch(error => {
          this.reportUnhandledError(error);
        });
    }
  }
};
</script>
